// @spec AI-STR-010
// Document upload page for AI analysis

import { createFileRoute } from '@tanstack/react-router';
import { useCallback } from 'react';

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { AIDocumentList, AIDocumentUploadZone } from '@/features/ai/documents';

export const Route = createFileRoute('/_authenticated/ai/documents/')({
  component: AIDocumentsPage,
});

function AIDocumentsPage() {
  const handleUploadComplete = useCallback(() => {
    // Documents list will auto-refresh via query invalidation
  }, []);

  return (
    <div className="p-8">
      <div className="mx-auto max-w-5xl">
        <div className="mb-8">
          <h1 className="text-2xl font-semibold">AI Documents</h1>
          <p className="mt-2 text-muted-foreground">
            Upload documents for AI-powered analysis and insights. Documents are processed and
            indexed for use in conversations and compliance assistance.
          </p>
        </div>

        {/* Upload Zone */}
        <Card className="mb-8">
          <CardHeader>
            <CardTitle>Upload Document</CardTitle>
            <CardDescription>
              Upload PDF, Word, Excel, or image files. Documents will be automatically processed and
              indexed for AI analysis.
            </CardDescription>
          </CardHeader>
          <CardContent>
            <AIDocumentUploadZone onUploadComplete={handleUploadComplete} />
          </CardContent>
        </Card>

        {/* Documents List */}
        <Card>
          <CardHeader>
            <CardTitle>Your Documents</CardTitle>
            <CardDescription>
              Documents uploaded for AI analysis. Processing status is updated automatically.
            </CardDescription>
          </CardHeader>
          <CardContent>
            <AIDocumentList />
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
